import { render, staticRenderFns } from "./PrivateUserProfile.vue?vue&type=template&id=8d1b613c&"
import script from "./PrivateUserProfile.vue?vue&type=script&lang=js&"
export * from "./PrivateUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PrivateUserProfile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports